<template>
    <div class="animated fadeIn">
        <loading :active.sync="isLoading"></loading>
        <b-row class="checkout-row">
            <b-col md="12" sm="12" lg="10">
                <b-row style="margin-bottom:20px;">
                    <b-col lg="10" md="10" sm="8" style="align-items: flex-end;display: flex;">
                        <b-row style="width:100%;">
                        <b-col lg="8" md="7" sm="7">
                            <label for="clients">{{ $t('menu.select_client') }}</label>
                            <b-form-select id="clients" v-model="selectedClient" @onSelect="selectChanged()"
                            :plain="true"
                            :options="clients">
                            </b-form-select>
                        </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="checkout-row">
                    <b-col class="product-col" md="12" sm="12" lg="12" v-for="(product, index) in products">
                       <b-row>
                           <b-col class="contered" lg="1" sm="1" md="1">
                               <!-- <div> -->
                                    <i @click="removeFromCart(product.id)" class="fa fa-times"></i>
                                <!-- </div> -->
                           </b-col>
                           <b-col class="contered" lg="2" sm="2" md="2">
                                <!-- <div class="image"> -->
                                    <img class="product-image" :src="product.image" alt="product-image" />
                                <!-- </div> -->
                           </b-col>
                           <b-col class="contered" lg="4" sm="3" md="3">
                                <div class="description text-center">
                                    <b>{{product.title}}</b>
                                    <p v-html="product.description"></p>
                                </div>
                           </b-col>
                           <b-col class="contered" lg="1" sm="1" md="2">
                                <div class="total-price"> {{product.price}} ₪</div>
                           </b-col>
                           <b-col class="contered" lg="2" sm="2" md="2">
                                <div class="total-price"> Delivery  {{!!product.delivery_price ? product.delivery_price : 0}} ₪</div>
                           </b-col>
                           <b-col class="contered" lg="1" sm="1" md="4">
                               <b-button @click="add(product)">+</b-button>
                                <div class="qty">{{product.qty}}</div>
                               <b-button @click="rm(product)">-</b-button>
                           </b-col>
                        </b-row>
                        <!-- <div class="item" >
                            <div class="buttons" @click="removeFromCart(product.id)">
                                <i class="fa fa-times"></i>
                            </div>

                            <div class="image">
                                <img :src="serverUrl+product.image" alt="product-image" />
                            </div>

                            <div class="description">
                                <b>{{product.title}}</b>
                                <p v-html="product.description"></p>
                            </div>
                            <div class="total-price">$ {{product.price}}</div>
                            <div class="qty">1</div>
                        </div> -->
                    </b-col>
                </b-row>
                <b-row class="checkout-row checkout-btn-row">
                    <b-col md="10" sm="10" lg="8" style="justify-content: center;display: flex;">
                        TOTAL : {{totalAmount}} ₪
                    </b-col>
                </b-row>
                <b-row class="checkout-row checkout-btn-row">
                    <b-col md="10" sm="10" lg="8" style="justify-content: center;display: flex;">
                        <PayPal v-if="!!selectedClient" :amount="totalAmount" currency="ILS" @payment-authorized="authorized($event)" @payment-cancelled="cancelled($event)" @payment-completed="completed($event)" :client="paypal" env="sandbox"></PayPal>
                        <p style="color:red;" v-if="!selectedClient">{{ $t('shop.select_client') }}</p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
    import Models from '@/store/ORM/models.js';
    import CmsService from '@/services/cms.service.js';
    var moment = require('moment');
    import PayPal from 'vue-paypal-checkout';
    import * as constants from '../helpers/Constants.js';
    import axios from 'axios';

    //Sandbox Email PSW
    //sb-f43pdm723645@personal.example.com
    //Te1f*Hd1
export default {
    name: 'checkout',
    components: {PayPal},
    data: function () {
        return {
            paypal: {
                sandbox: 'ARLHjspwH3GQ8oJpd0qO1WKmX6pgVUDa3YEmu5lXMu45utzCYVBSCiQ3A1dcXCjKRTw8Gx-6hBisaxkI',
                    production: '<production client id>'
                },
            cart: Models.Cart.query().first(),
            amount : '',
            user : this.$store.state['UserModules'].user,
            isLoading : false,
            serverUrl : constants.serverUrl,
            selectedClient: null,
            postCheckout : constants.postCheckout
        }
    },

    mounted() {
    },

    computed: {
        products() {
            return Models.Product.query().where('cart_id',this.cart.id).get();
        },
        totalAmount() {
            let amount = 0;
            this.products.forEach((product,index ) => {
                amount = amount + (parseFloat(product.price) * product.qty );
                if(!!product.delivery_price){
                    amount = amount + parseFloat(product.delivery_price);
                }
            });
            return amount.toString();
        },
        clients() {
            let cli = Models.Client.all();
            let options = []
            for (let i in cli) {
                let repr = cli[i].id + ' ' + cli[i].first_name + ' ' + cli[i].last_name
                var d = new Object()
                d.text = repr
                d.value = cli[i].id
                options.push(repr)
            }
            return options
        },
    },

    methods: {
        removeFromCart(id) {
            Models.Product.delete(id);
        },

        authorized(event){
            // console.log(event)
        },
        cancelled(event){
            // console.log(event)
        },
        completed(event){
            console.log(event);
            this.pay(event);
        },

        add(prod){
            prod.qty = prod.qty+1;
            Models.Product.update({data: prod});
        },
        rm(prod){
            if(prod.qty == 1){
                Models.Product.delete(prod.id);
            }else{
                prod.qty = prod.qty-1;
                Models.Product.update({data: prod});
            }

        },

        pay (event) {
            this.isLoading = true;
            let backend_url = this.serverUrl+this.postCheckout;
            let vm = this;

            let headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            };

            let data = {
                products : this.products,
                user_id : this.user.id,
                transaction_id : event.id,
                status : event.state,
                client_id : this.selectedClient.split(' ')[0],
                total : event.transactions[0].amount.total
            };

            axios.post(backend_url, data, {
                headers: headers
            })
            .then(function (response) {
                if(response.data.success){
                    vm.$toastr.success(response.data.message);
                    Models.Product.deleteAll();
                    setTimeout(function(){ 
                        vm.$router.push('shop');
                    }, 500);
                }else{
                    vm.$toastr.error(response.data.message);
                }
                 vm.isLoading = false;
            })
            .catch(function (error) {
                // vm.$toastr.error(error.data.message);

                 vm.isLoading = false;
                setTimeout(function(){ 
                    vm.$router.push('shop');
                }, 500);
            });
        },
    }
}
</script>
<style>
    .contered{
        justify-content:center;
        align-items:center;
        display:flex;
    }

    /* .shopping-cart {
        height: auto;
        margin: 80px auto;
        background: #FFFFFF;
        box-shadow: 1px 2px 3px 0px rgba(0,0,0,0.10);
        border-radius: 6px;
    } */

    /* .title {
        height: 60px;
        padding: 20px 30px;
        color: #5E6977;
        font-size: 18px;
        font-weight: 400;
    } */

    /* .item {
        padding: 20px 30px;
        height: 140px;
        display: flex;
        border-bottom: 1px solid #E1E8EE;
    } */

    .item:nth-child(3) {
        border-top:  1px solid #E1E8EE;
        border-bottom:  1px solid #E1E8EE;
    }

    .checkout-row{
        justify-content:center;
    }

    .product-col{
        margin-bottom:5px;
        background-color: #fff;
    }

    /* .buttons {
        position: relative;
        padding-top: 30px;
        margin-right: 60px;
        cursor: pointer;
    }
     */
    .checkout-btn-row{
        margin-top:50px;
    }

    .delete-btn,
    .like-btn {
        display: inline-block;
        Cursor: pointer;
    }
    .delete-btn {
        width: 18px;
        height: 17px;
    }

    .is-active {
        animation-name: animate;
        animation-duration: .8s;
        animation-iteration-count: 1;
        animation-timing-function: steps(28);
        animation-fill-mode: forwards;
    }
    .qty{
        display:flex;
        margin-left:5px;
        margin-right:5px;
    }

    /* .btn-primary {
        width: 5% !important;
        background-color: #20a8d8 !important;
        border-color: #20a8d8 !important;
    } */
 
    @keyframes animate {
        0%   { background-position: left;  }
        50%  { background-position: right; }
        100% { background-position: right; }
    }

    .image {
        margin-right: 50px;
    }

    .image img {
        max-height: 100px;
        width: auto;
        max-width: 119px;
    }
     
    /* .description {
        padding-top: 10px;
        margin-right: 60px;
        width: 115px;
    }
     
    .description span {
        display: block;
        font-size: 14px;
        color: #43484D;
        font-weight: 400;
    }
     
    .description span:first-child {
        margin-bottom: 5px;
    }
    .description span:last-child {
        font-weight: 300;
        margin-top: 8px;
        color: #86939E;
    }
      */
    /* button[class*=btn] {
        width: 30px;
        height: 30px;
        background-color: #E1E8EE;
        border-radius: 6px;
        border: none;
        cursor: pointer;
    } */
     
    /* button:focus,
    input:focus {
        outline:0;
    } */

    .total-price {
        width: auto;
        /* padding-top: 27px; */
        text-align: center;
        font-size: 16px;
        color: #43484D;
        font-weight: 300;
    }

    .product-image{
        width: 100%;
    }

    /* .items {
        padding-left: 25%;
        padding-right: 25%;
    } */

    .vld-overlay.is-full-page{
        z-index:9999;
    }
</style>